import { IoText } from "react-icons/io5";

const getDataFieldsWordcloud = () => {
  return [
    {
      title: "Name",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    // {
    //     title: "Sub Boxes",
    //     type: "dropzone",
    //     single: true,
    //     dataTypeAllowed: "all",
    //     reduxKey: "rows",
    //     itemInArray: true,
    // },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: Number,
    },
  ];
    return [
        {
            title: "Name",
            type: "dropzone",
            single: true,
            dataTypeAllowed: "all",
            reduxKey: "groupByFields",
            itemInArray: true,
        },
        // {
        //     title: "Sub Boxes",
        //     type: "dropzone",
        //     single: true,
        //     dataTypeAllowed: "all",
        //     reduxKey: "rows",
        //     itemInArray: true,
        // },
        {
            title: "Metrics",
            type: "dropzone",
            single: true,
            dataTypeAllowed: "all",
            reduxKey: "valueColumns",
            itemInArray: true,
        },
        {
            title: "Filters",
            type: "dropzone",
            single: false,
            dataTypeAllowed: "all",
            reduxKey: "filters",
            itemInArray: true,
        },
        {
            title: "Tooltip",
            type: "dropzone",
            single: false,
            dataTypeAllowed: "all",
            reduxKey: "tooltip",
            itemInArray: true,
        },
        {
            title: "Row Limit",
            type: "dropdown",
            reduxKey: "rowLimit",
            itemInArray: false,
            defaultValue: 500, valueType: Number
        },


    ];
};

const getCustomizationFieldWordcloud = () => {
    return [

        {
            title: "Color",
            type: "COLOR",
            reduxKey: "colorSchemeid",
            defaultType: "RANDOM",
        },
        //textbox
        {
            title: "Title",
            type: "CONTAINER_WITH_TOGGLE",
            defaultValue: false,
            reduxKey: "isTileVisible",
            innerComponents: [
                {
                    title: "Title",
                    type: "text",
                    defaultValue: "title...",
                    minValue: 0,
                    maxValue: 20,
                    reduxKey: "Title",
                    isParent: true,
                    parentType: "CONTAINER_WITH_TOGGLE",
                },
                {
                    title: "Bold",
                    type: "checkbox",
                    defaultValue: false,
                    reduxKey: "isTitleBold",
                    isParent: true,
                },
                {
                    title: "Title Color",
                    type: "fontColor",
                    reduxKey: "TitleFontColor",
                    parentType: "CONTAINER_WITH_TOGGLE",
                    isParent: true,
                    defaultValue: "#bababa",
                },
                {
                    title: "Title Size",
                    type: "range",
                    defaultValue: 25,
                    minValue: 8,
                    maxValue: 30,
                    reduxKey: "TitleSize",
                    isParent: true,
                    parentType: "CONTAINER_WITH_TOGGLE",
                },

                {
                    title: "Value Align",
                    type: "textAlign",
                    reduxKey: "valueAlign",
                    defaultValue: "center",
                },



            ],
        },



    ];
};

const getWordCloudChartDetails = () => {
  return {
    chartType: "echarts",
    imageSrc: "/graph_img/wordcloud.png",
    label: "WordCloud",
    value: "wordcloudchart",
    icon: <IoText className="text-xl text-blue-950" />,
    fileName: "WordCloudChartComp.js",
  };
};
export {
  getDataFieldsWordcloud,
  getCustomizationFieldWordcloud,
  getWordCloudChartDetails,
};
